import { useEffect, useState } from "react"
import GlobalSpinner from "../globalsSpinner/GlobalSpinner";
import { OfflineModeToggleRequest, PlayNowOfflineList, getPlayNowOffline, offlineModeDisable, offlineModeEnable } from "../../../api/playersApi";
import { useParams } from "react-router-dom";
import { Guid } from "../../../api/baseApi";

interface CheckedItems {
    [key: string]: boolean;
}

const PlayNowOffline = () => {
    let [isLoading, setIsLoading] = useState(false);
    let [playNowOfflineList, setPlayNowOfflineList] = useState<PlayNowOfflineList[]>([]);
    let [checkedItems, setCheckedItems] = useState<CheckedItems>({});

    let {id : playerId} = useParams<{id:string}>();

    useEffect(()=>{
        async function fetchData(){
            setIsLoading(true);
            await Promise.all([updatePlayNowOfflineList()]);
            setIsLoading(false);
        }

        fetchData()
    },[])

    useEffect(() => {
        const initialCheckedItems: CheckedItems = {};
        playNowOfflineList.forEach(item => {
            initialCheckedItems[item.playNowId] = item.isEnabled;
        });
        setCheckedItems(initialCheckedItems);
    },[playNowOfflineList])


    const updatePlayNowOfflineList = async () => {
        let result = await getPlayNowOffline(playerId)
        if(result.type === "succes") {
            setPlayNowOfflineList(result.data.items)
        }
    }

    const handleCheckboxChange = async (id: Guid) => {

        let req: OfflineModeToggleRequest = {
            playNowId: id
        }

        setIsLoading(true)
        if(checkedItems[id]){
            await offlineModeDisable(playerId, req)
        } else {
            await offlineModeEnable(playerId, req)
        }

        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));

        await updatePlayNowOfflineList()
        setIsLoading(false)
    };

    const renderPlayNowLogs = (items: PlayNowOfflineList[]) => {
        return items.map( item => {
            return <tr key={item.playNowId}>
                <td>{item.hotKey}</td>
                <td>{item.name}</td>
                <td>
                    <label htmlFor={`offline-${item.playNowId}`} className="checkbox-control">
                        <input 
                            id={`offline-${item.playNowId}`} 
                            className="checkbox" 
                            type="checkbox" 
                            checked={checkedItems[item.playNowId]}
                            onChange={() => handleCheckboxChange(item.playNowId)}
                        />
                        <span className="checkbox-bg"></span>
                        <span className="checkbox-cursor"></span>
                    </label>
                </td>
            </tr>
        })
    }

    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <td>Hotkey</td>
                        <td>PlayNow Playlist</td>
                        <td>Offline Mode Enabled</td>
                    </tr>
                </thead>
                <tbody>
                    {renderPlayNowLogs(playNowOfflineList)}
                </tbody>
            </table>

            <GlobalSpinner isShow={isLoading} />
        </>
    )
}

export default PlayNowOffline